function resolveBuilderEditScope(inBuilderEditScope) {
  return Boolean(typeof inBuilderEditScope === "function" ? inBuilderEditScope() : inBuilderEditScope);
}

function suppressesNavigation(surface) {
  return Boolean(surface?.editMode) || resolveBuilderEditScope(surface?.inBuilderEditScope);
}

module.exports = { suppressesNavigation, resolveBuilderEditScope };
module.exports.default = { suppressesNavigation, resolveBuilderEditScope };
